import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzNpday65 } from './pages'

type TIdToPageMapWoofzNpday65 = Record<PageIdWoofzNpday65, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_NPDAY_65: TIdToPageMapWoofzNpday65 = {
  [PageId.SUBSCRIPTIONS_NPDAY_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_65/pages/subscriptions/SubscriptionNpday65'
      ).then((m) => ({
        default: m.SubscriptionsNpday65,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_65/pages/subscriptions/SubscriptionNpday65'
      ),
  },
  [PageId.CHAT_UPSELL_NPDAY_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_65/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_65/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_NPDAY_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_65/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_npday/woofz_npday_65/pages/upsell/Upsell'),
  },
  [PageIdWoofzNpday65.DOWNLOAD_NPDAY_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_65/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_npday/woofz_npday_65/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzNpday65.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
